/**
 * Permissões do Controle de Produção — as chaves cadastradas no SSO.
 *
 * São exatamente as da planilha `roles_controle_de_producao.xlsx`, coluna
 * `Chave`. Se divergirem de uma letra, o botão some para quem tem direito ou
 * aparece para quem não tem.
 *
 * Formato do SSO: `<modulo>.<acao>`, snake_case sem acento. O aplicativo
 * (`Controle de Produção`) é campo separado lá e não entra na chave.
 */
export const PERMISSOES = {
  DASHBOARD_VISUALIZAR: 'dashboard.visualizar_painel',

  ORDEM_VISUALIZAR: 'ordem_de_producao.visualizar',
  ORDEM_CRIAR: 'ordem_de_producao.criar',
  ORDEM_EDITAR: 'ordem_de_producao.editar',
  ORDEM_CANCELAR: 'ordem_de_producao.cancelar',

  QUEBRA_VISUALIZAR: 'quebra_de_producao.visualizar',
  QUEBRA_INICIAR: 'quebra_de_producao.iniciar',
  QUEBRA_CONCLUIR: 'quebra_de_producao.concluir',
  QUEBRA_CANCELAR: 'quebra_de_producao.cancelar',

  KANBAN_VISUALIZAR: 'kanban.visualizar',
  APONTAMENTO_REGISTRAR: 'chao_de_fabrica.registrar_apontamento',

  PRODUTO_VISUALIZAR: 'produto.visualizar',
  PRODUTO_GERENCIAR: 'produto.gerenciar',

  RFID_VISUALIZAR: 'rfid.visualizar',
  RFID_GERENCIAR: 'rfid.gerenciar',
  RFID_BLOQUEAR: 'rfid.bloquear',
  RFID_REGISTRAR_EVENTO: 'rfid.registrar_evento',

  FLUXO_VISUALIZAR: 'fluxo_de_producao.visualizar',
  FLUXO_GERENCIAR: 'fluxo_de_producao.gerenciar',

  RECEITA_VISUALIZAR: 'receita_de_maquina.visualizar',
  RECEITA_GERENCIAR: 'receita_de_maquina.gerenciar',

  RELATORIO_VISUALIZAR: 'relatorio.visualizar',
  RELATORIO_EXPORTAR: 'relatorio.exportar',

  USUARIO_VISUALIZAR: 'usuario.visualizar',
  AUDITORIA_VISUALIZAR: 'auditoria.visualizar',

  OBSERVABILIDADE_VISUALIZAR: 'observabilidade.visualizar',
  SINCRONIZACAO_VISUALIZAR: 'sincronizacao.visualizar',
  SINCRONIZACAO_EXECUTAR: 'sincronizacao.executar',
}

export const TODAS_AS_PERMISSOES = Object.values(PERMISSOES)

/**
 * Se o usuário tem ALGUMA permissão deste aplicativo.
 *
 * Comparação por chave exata, nunca por prefixo: `rfid.` também é usado por
 * outro aplicativo no mesmo SSO (`rfid.relatorio_inventario.*`), e prefixo
 * daria falso positivo.
 */
export const temAlgumaPermissaoDoSistema = permissoes =>
  (permissoes || []).some(p => TODAS_AS_PERMISSOES.includes(String(p).trim().toLowerCase()))
